import {
    Box,
    Button,
    Flex,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Spacer,
    Text
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdSettings } from "react-icons/md";
import { AccountAvatar } from "./AccountAvatar";
import { CommentForm } from "../forms";
import { ShortAccountDataFragment } from "../graphql";
import { formatDateTime } from "../utils";

interface IComment {
  comment: {
    id: number;
    createdAt?: Date;
    updatedAt?: Date;
    content: string;
    author: ShortAccountDataFragment;
  };
  loggedUser: {
    me: {
      id: number;
    };
  };
  onSubmit: (id: number, content: string) => Promise<void>;
  onDelete: (id) => Promise<void>;
}

export const Comment: React.FC<IComment> = ({
    comment,
    loggedUser,
    onSubmit,
    onDelete
}) => {
    const { t } = useTranslation();
    const [isEditing, setIsEditing] = useState(false);

    const mineComment = comment.author.id === loggedUser.me.id;
    const mineProps = {
        bg: "#edf2f6",
        border: "1px solid #F1F0F0"
    };

    const otherProps = {
        bg: "#F3FAFF",
        border: "1px solid #E6F4FF"
    };

    return (
        <Box
            p={ 2 }
            m={ 2 }
            borderRadius="lg"
            key={ comment.id }
            { ...otherProps }
            { ...(mineComment ? mineProps : otherProps) }
        >
            <Flex>
                <AccountAvatar
                    account={ comment.author }
                    size="sm"
                    key={ comment.id }
                    role={ false }
                />
                <Spacer />
                <Box marginRight="5px">
                    <Text fontSize="sm">
                        { formatDateTime(comment.updatedAt || comment.createdAt) }
                    </Text>
                </Box>
                { mineComment ? (
                    <Menu size="sm">
                        <MenuButton as={ Button }>
                            <MdSettings />
                        </MenuButton>
                        <MenuList>
                            <MenuItem onClick={ () => setIsEditing(!isEditing) }>
                                { isEditing ? t("forms.view") : t("forms.edit") }
                            </MenuItem>
                            <MenuItem onClick={ () => onDelete(comment.id) }>
                                { t("forms.delete") }
                            </MenuItem>
                        </MenuList>
                    </Menu>
                ) : null }
            </Flex>

            { isEditing ? (
                <Box bg="white">
                    <CommentForm
                        onSubmit={ async (values) => {
                            await onSubmit(comment.id, values.content);
                            setIsEditing(false);
                        } }
                        initialValues={ { content: comment.content } }
                    ></CommentForm>
                </Box>
            ) : (
                <Text p="5px">{ comment.content }</Text>
            ) }
        </Box>
    );
};
